const DojoConfig = require('@/lib/PaymentMethods/Dojo/DojoConfig');
const DojoDriver = require('@/lib/PaymentMethods/Dojo/DojoDriver');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');

app.factory(
    'dojoConfig',
    /**
     * @param hydrator
     * @param {AppConfig} appConfig
     * @param {CurrentDevice} currentDevice
     * @param {PaymentMethodService} paymentMethodService
     */
    function (
        hydrator,
        appConfig,
        currentDevice,
        paymentMethodService
    ) {
        let config = new DojoConfig();
        let device = currentDevice.device;

        let paymentMethod = paymentMethodService.getByRef(PaymentMethodRef.CARD_DOJO_CHIP_AND_PIN);
        if (!paymentMethod) {
            throw new Error('Company does not have Dojo payment method enabled.');
        }

        // Set config from the company's payment method config.
        if (paymentMethod.config) {
            let companyTerminalConfig = JSON.parse(paymentMethod.config);
            hydrator.hydrate(companyTerminalConfig, config);
        }

        // Set config from the device's payment method config.

        if (device.paymentTerminalConfig) {
            if (device.paymentTerminalConfig.hasOwnProperty(PaymentMethodRef.CARD_DOJO_CHIP_AND_PIN)) {
                hydrator.hydrate(device.paymentTerminalConfig[PaymentMethodRef.CARD_DOJO_CHIP_AND_PIN], config);
            }
        }

        // We can set the username to whatever we want so let's use our device.
        config.username = String(device.ID);

        console.log('[DojoConfig]', config);

        setupSimulator(appConfig);

        return config;
    }
);

const setupSimulator = function (appConfig) {
    // WebPOS is a simple JavaScript API that gets injected into the window object when ProPoint is running
    // inside the Dojo WebPOS Android application. In development, we inject a very lightweight mock instead.
    if (appConfig.isDev && !window.WebPOS) {
        require('@/lib/PaymentMethods/Dojo/DojoWebPosSimulator');
    }
};

app.service('dojoDriver', DojoDriver);
